/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {
  CacheType,
  createObservableDataAction,
  IAction,
  IActionContext,
  IActionInput,
  IAny,
  ICreateActionContext,
  IGeneric,
} from "@msdyn365-commerce/core";

/**
 * LoyaltyCardState Input Action
 */

export class ModulesStateShareInput implements IActionInput {
  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `modulesSharedState`;
  public getCacheObjectType = () => "modulesSharedState";
  public dataCacheType = (): CacheType => "request";
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IModulesSharedState {
  customerLoyaltyTierId: string | undefined;
  categoryName: string | undefined;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  inputData: ICreateActionContext<IGeneric<IAny>>
): IActionInput => {
  return new ModulesStateShareInput();
};
/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function sampleStateAction(
  input: ModulesStateShareInput,
  ctx: IActionContext
): Promise<IModulesSharedState> {
  return { customerLoyaltyTierId: undefined, categoryName: undefined };
}

/**
 * SampleState - create action
 */
export default createObservableDataAction<IModulesSharedState>({
  action: <IAction<IModulesSharedState>>sampleStateAction,
  input: createInput,
});
